<template>
	<div class="public-wrap" :class="{'mobile': mobile}">
		<div class="chat-wrap">
			<div class="public-navbar">
				<div class="go-back" v-if="mobile" @click="goBack">
					<span class="material-icons">arrow_back_ios</span>
				</div>
				<div class="navbar-text">
					<span>{{$t('chat.boothChat')}}</span>
					<!-- <span>{{$t('chat.publicChatSubtitle')}}</span> -->
				</div>
			</div>
			<transition name="chat-fade">
				<div class="scroll-to-bottom" v-if="hasNewMsg" @click="clickScrollToBottom()">
					<span class="material-icons">keyboard_arrow_down</span>
				</div>
			</transition>
			<div class="chat-messages" @scroll.stop="handleScroll">
				<div class="loading-div">1</div>

				<div
					v-for="(msg, i) in messages.filter(item => {if (item.content) return item;})"
					:key="msg.id"
					:ref="'msg'+msg.id"
					class="individual-message"
					:class="typeOfMsg(msg, i)"
				>
					<div class="img-wrap" @click="goToProfile(msg)">
						<img :src="msg.imageURL" draggable="false" v-if="shouldShowImage(msg, i)" />
					</div>
					<span
						class="content"
						v-html="msg.content.replace(/</g,'<span><</span>')"
						v-linkified
						@mouseenter="setShowreport(msg, true)"
					></span>
					<div
						class="report"
						v-if="senderNotMe(msg)"
						@mouseenter="setShowreport(msg, true)"
						@mouseleave="setShowreport(msg, false)"
					>
						<transition name="chat-fade">
							<img
								:src="$images.reportIcon"
								draggable="false"
								v-if="msg.showReport"
								@click="reportMsg(msg.id)"
							/>
						</transition>
					</div>
					<span class="timestamp">{{msg.timestamp}}</span>
					<span
						class="name"
						v-if="msg.sender !== usrId && shouldShowImage(msg, i)"
					>{{msg.name}} {{msg.lastname}}</span>
				</div>
				<div class="padding-div">1</div>
			</div>

			<div class="input-wrap">
				<custominput :block="sendMsgBlockTimer" v-on:send="handleSend" />
			</div>
		</div>
	</div>
</template>

<script>
import api from "../../api";
import moment from "moment";
import custominput from "@/components/chat/Input.vue";
import messageMixin from "./messageMixin";
export default {
	components: {
		custominput
	},
	data() {
		return {
			messages: [],
			usr_id: null,
			topMsgId: null,
			hasNewMsg: false,
			refresTimer: null,
			currentLimit: 50,
			loadingNewMessages: false,
			sendMsgBlockTimer: 0
		};
	},
	props: {
    loc_id: Number,
		orientation: Boolean,
		mobile: Boolean
	},
	mounted() {
		this.init();
	},
	beforeDestroy() {
		this.stopUpdate();
	},
	mixins: [messageMixin],
	methods: {
		goBack() {
			this.$emit("goback");
		},
		setShowreport(msg, bool) {
			if (msg.sender != this.getMyUsrId())
				this.$nextTick(() => {
					this.$set(msg, "showReport", bool);
				});
		},
		async init() {
			this.usrId = Number(localStorage.getItem("usr_id"));
			const params = {
        limit: this.currentLimit,
        id: this.loc_id,
      };

			try {
				let res = await api.getBoothMessages(params);
				this.transformApiData(res.data.data);
			} catch (error) {
				this.handleError(error);
			}

			if (this.refresTimer) {
				clearTimeout(this.refresTimer);
				this.refresTimer = null;
			}
			this.refresTimer = setInterval(() => {
				this.refreshMessages();
			}, 3000);
			setTimeout(() => {
				this.scrollToLast();
			}, 0);
		},
		async transformApiData(arr) {
			let newArr = [];
			for (let i = 0; i < arr.length; i++) {
				const el = arr[i];

				let formatData = {
					id: el.msg_id,
					name: el.usr_firstname,
					lastname: el.usr_lastname,
					imageURL: await this.getImageUsdId(el.usd_id),
					content: el.msg_text,
					sender: el.usr_id,
					timestamp: this.formatTime(el.msg_sent)
				};
				newArr.push(formatData);
			}
			this.messages = newArr;
			this.topMsgId = this.messages[0] ? this.messages[0].id : null;
		},
		async refreshMessages() {
			try {
				let obj = {
					limit: this.currentLimit,
          id: this.loc_id,
				};
				let res = await api.getBoothMessages(obj);
				this.trasnformRefresh(res.data.data);
			} catch (error) {
				this.handleError(error);
			}
		},
		async trasnformRefresh(arr) {
			let newArr = [];
			for (let i = 0; i < arr.length; i++) {
				const el = arr[i];
				let formatData = {
					id: el.msg_id,
					name: el.usr_firstname,
					lastname: el.usr_lastname,
					imageURL: await this.getImageUsdId(el.usd_id),
					content: el.msg_text,
					sender: el.usr_id,
					timestamp: this.formatTime(el.msg_sent)
				};
				newArr.push(formatData);
			}
			if (newArr.length == 0) return;
			let code = this.arraysAreSame(newArr, this.messages);
			if (code == 2 || code == 1) {
				this.messages = newArr;
				this.topMsgId = this.messages[0].id;
				this.showScrollToBottomButton(true);
				this.scrollToLast();
			}
		},
		async fetchNewMessages() {
			if (this.loadingNewMessages) return;
			this.loadingNewMessages = true;
			this.currentLimit += 50;

			try {
				let obj = {
					limit: this.currentLimit,
          id: this.loc_id,
				};
				let res = await api.getBoothMessages(obj);
				this.trasnformAPIResponseForAdditional(res.data.data);
			} catch (error) {
				this.handleError(error);
			}
			this.loadingNewMessages = false;
			console.log(this.currentLimit);
		},
		async trasnformAPIResponseForAdditional(arr) {
			let newMessages = [];
			for (let i = 0; i < arr.length; i++) {
				const el = arr[i];

				let formatData = {
					id: el.msg_id,
					name: el.usr_firstname,
					lastname: el.usr_lastname,
					imageURL: await this.getImageUsdId(el.usd_id),
					content: el.msg_text,
					sender: el.usr_id,
					timestamp: this.formatTime(el.msg_sent)
				};
				newMessages.push(formatData);
			}

			if (newMessages.length == 0) return;
			let code = this.arraysAreSame(this.messages, newMessages);
			switch (code) {
				case 1:
				case 3:
					this.messages = newMessages;
					this.scrollToRef();
					this.topMsgId = this.messages[0].id;
					this.showScrollToBottomButton(true);
					break;
				case 2:
					this.messages = newMessages;
					this.scrollToRef();
					this.topMsgId = this.messages[0].id;
					this.showScrollToBottomButton(true);
					break;
				default:
					this.currentLimit -= 50;
					break;
			}
		},
		handleScroll(evt) {
			let currentScrollH = evt.target.scrollTop + evt.target.offsetHeight;
			let maxScrollH = evt.target.scrollHeight;
			if (maxScrollH - currentScrollH > 100) {
				this.showScrollToBottomButton(true);
			}
			if (maxScrollH - currentScrollH === 0) {
				this.showScrollToBottomButton(false);
			}
			if (evt.target.scrollTop <= 0) {
				this.fetchNewMessages();
			}
		},
		arraysAreSame(x, y) {
			// returns code status
			if (x.length == 0 || x.length !== y.length) return 1;
			if (!this.objectsAreSameOG(x[x.length - 1], y[y.length - 1])) return 2;
			if (!this.objectsAreSameOG(x[0], y[0])) return 3;
			return 0;
		},
		objectsAreSameOG(x, y) {
			var objectsAreSame = true;
			let keysX = Object.keys(x);
			let keysY = Object.keys(y);
			if (keysX.length !== keysY.length) return false;
			// Create a set of keys - no duplicates
			// We expect most keys to overlap
			// In the event they don't - object will have a key that the other doesn't
			// which will cause an undefined !== to something
			let keysUnion = {};
			// From all keys from first object
			for (let i = 0; i < keysX.length; i++) {
				keysUnion[keysX[i]] = true;
			}
			// From all keys from second object
			for (let i = 0; i < keysY.length; i++) {
				// Optimization: If you find a key in the other object that doesn't exist in the first one
				// break early - objects are are not the same
				if (keysUnion[keysY[i]] !== true) {
					return false;
				}
			}

			let allKeys = Object.keys(keysUnion);

			// Check both object properties
			for (let i = 0; i < allKeys.length; i++) {
				let propertyName = allKeys[i];
				if (x[propertyName] != y[propertyName]) {
					objectsAreSame = false;
					break;
				}
			}
			return objectsAreSame;
		},
		formatTime(timestamp) {
			let time = moment.utc(timestamp).fromNow();
			return time;
		},
		shouldShowImage(msg, i) {
			let messages = this.messages;
			let myUsrId = this.getMyUsrId();
			if (
				msg.sender != myUsrId &&
				(messages[i + 1] === undefined ||
					messages[i + 1] === null ||
					messages[i + 1].sender !== msg.sender)
			)
				return true;
		},
		async handleSend(text) {
			const No_OF_SECONDS_FOR_BLOCK = 10;
			let obj = {
        id: this.loc_id,
				text: text
			};
			if (obj.text) {
				try {
					this.sendMsgBlockTimer = No_OF_SECONDS_FOR_BLOCK;
					await api.sendBoothMessage(obj);
				} catch (error) {
					this.handleError(error);
				}
				setTimeout(() => {
					this.sendMsgBlockTimer = 0;
				}, No_OF_SECONDS_FOR_BLOCK * 1000);
				this.init();
			}
		},
		scrollToLast() {
			if (this.messages.length <= 0) return;
			setTimeout(() => {
				let noOfMsg = this.messages.length;
				let lastId = this.messages[noOfMsg - 1].id;
				let msgId = "msg" + lastId;
				let msg = this.$refs[msgId] ? this.$refs[msgId][0] : null;
				if (msg) msg.scrollIntoView();
			}, 0);
		},
		goToProfile(msg) {
			let usr_id = msg.sender;
			let ext = msg.name + "-" + msg.lastname + "-" + usr_id;
			this.$router.push("/profile/" + ext.toLowerCase());
      if (this.mobile) this.closeChat();
		}
	}
};
</script>

<style lang="scss" scoped>
@mixin flex-end {
	display: flex;
	justify-content: flex-end;
	align-items: center;
}
@mixin flex-start {
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
}
@mixin flex-between {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
@mixin flex-center {
	display: flex;
	justify-content: center;
	align-items: center;
}

.public-wrap {
	position: relative;
	height: calc(100% - 100px);
	width: calc(100% - 20px);
	@include flex-center();
	padding: 10px;
	background-image: url("../../assets/backgrounds/public-background.png");
	background-size: 105% auto;
	background-repeat: no-repeat;
	background-position: -35px -80px;
	&.mobile {
		background: none;
		height: calc(100% - 70px);
		.chat-wrap {
			padding-top: 10px;
			width: 90%;
			height: 100%;
			.go-back {
				@include flex-center();
				width: 20%;
			}
			.chat-messages {
				height: calc(100% - 60px - 65px);
				.individual-message {
					.content {
						word-wrap: break-word;
					}
					a {
						color: aqua;
					}
				}
			}
		}
		.chat-messages {
			height: 300px;
			overflow: auto;
		}
	}
}
.chat-wrap {
	width: 55%;
	height: 100%;
	position: relative;
	background: #ffffff;
	box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
	border-radius: 30px;
}

.input-wrap {
	position: absolute;
	bottom: 0px;
	width: calc(100% - 20px);
	height: 65px;
	padding: 0 10px;
	border-radius: 0 0 30px 30px;
	background-color: white;
	user-select: none;
}
.public-navbar {
	height: 60px;
	@include flex-end();
	.navbar-text {
		width: 80%;
		@include flex-start();
		flex-direction: column;
		span:first-child {
			font-weight: 700;
		}
	}
}
.scroll-to-bottom {
	@include flex-center();
	z-index: 41;
	position: absolute;
	bottom: 70px;
	right: 15px;
	width: 30px;
	height: 30px;
	border-radius: 50%;
	border: 1px solid rgb(182, 182, 182);
	background: rgba(255, 255, 255, 0.66);
}
.chat-messages {
	position: relative;
	box-sizing: border-box;
	padding-left: 30px;
	padding-right: 10px;
	height: calc(100% - 130px);
	width: calc(100%);
	overflow-y: scroll;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
	.loading-div {
		color: transparent;
		width: 100%;
		height: 20px;
		@include flex-center();
	}
	.padding-div {
		color: transparent;
		line-height: 30px;
		height: 30px;
		width: 100%;
		@include flex-center();
	}
	.individual-message {
		position: relative;
		padding: 10px;
		width: 75%;
		margin: 10px 0;
		.content {
			position: relative;
			z-index: 2;
			word-wrap: break-word; // very important do not del
			box-sizing: border-box;
			text-align: left;
			padding: 0 10px;
			width: 100%;
			display: block;
		}
		a {
			color: aqua;
		}
		.report {
			@include flex-end();
			position: absolute;
			top: 50%;
			left: 0;
			transform: translate(0, -50%);
			width: 115%;
			height: 100%;
			img {
				cursor: pointer;
				position: relative;
				width: 30px;
				height: 30px;
				right: 10px;
				left: auto;
			}
		}
		.timestamp {
			color: black;
			position: absolute;
			right: 10px;
			bottom: -16px;
			opacity: 0.8;
			font-size: 11px;
		}
		.name {
			color: black;
			position: absolute;
			left: 10px;
			bottom: -16px;
			opacity: 0.8;
			font-size: 11px;
		}
	}
	.img-wrap {
		@include flex-center();
		position: absolute;
		width: 25px;
		height: 25px;
		border-radius: 50%;
		bottom: 0;
		left: -35px;
		overflow: hidden;
		img {
			cursor: pointer;
		}
	}
	img {
		height: 100%;
		max-width: none;
	}
	.my-msg {
		margin-right: 10px;
		align-self: flex-end;
		background-color: rgb(115, 50, 158);
		color: white;
	}
	.their-msg {
		margin-left: 15px;
		align-self: flex-start;
		box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.171);
	}
	.top-round {
		border-radius: 20px 20px 0 0;
	}
	.bot-round.my-msg {
		border-radius: 0 0 0 20px;
	}
	.bot-round.their-msg {
		border-radius: 0 0 20px 0;
	}
	.bot-round.top-round.my-msg {
		border-radius: 20px 20px 0 20px;
	}
	.bot-round.top-round.their-msg {
		border-radius: 20px 20px 20px 0;
	}
}
</style>